import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

jQuery( document ).ready( function( $ ) {
  document.querySelectorAll( '.block-factcards.is-slider .factcards.swiper' ).forEach( function( el ) {
    var scope = el.closest( '.block-factcards' ) || el.parentElement;
    new Swiper( el, {
      modules:       [ Navigation ],
      slidesPerView: 'auto',
      spaceBetween:  24,
      navigation:    {
        nextEl: scope.querySelector( '.swiper-button-next' ),
        prevEl: scope.querySelector( '.swiper-button-prev' ),
      },
    } );
  } );
} );
